import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService, TranslationService, UserIdService } from '@spartacus/core';
import { catchError, combineLatest, map, Observable, switchMap } from 'rxjs';
import { failStatus, StatusRequest, successStatus } from '../../../../core/models/request-status.model';
import {
  ProductsPricesRequest,
  ProductsPricesRequestConfig,
  ProductsRequest,
} from '../../../../core/models/product.model';
import { SimpleEntry } from '../../../../core/models/orderEntry.model';
import { CustomActiveCartService } from '../../cart/_core/active-cart.service';

@Injectable({
  providedIn: 'root',
})
export class ProductAuxConnector {
  constructor(
    private http: HttpClient,
    private occEndPointService: OccEndpointsService,
    private translationService: TranslationService,
    private userIdService: UserIdService,
    private activeCartService: CustomActiveCartService,
  ) {}

  getProductsPrices(config: ProductsPricesRequestConfig): Observable<ProductsPricesRequest> {
    return this.userIdService.getUserId().pipe(
      switchMap(userId => {
        const productsIDs = config.productsIDS.join(',');
        const url = this.occEndPointService.buildUrl('productsPrices', { urlParams: { userId, productsIDs } });

        return this.http.get(url).pipe(
          map((response: any) => {
            return {
              products: response,
              ...successStatus,
            };
          }),
          catchError(() => {
            return this.translationService.translate('generic.error').pipe(
              map(textError => ({
                message: textError,
                ...failStatus,
              })),
            );
          }),
        );
      }),
    );
  }

  getProductsByIDS(productIds: string[]): Observable<ProductsRequest> {
    const url = this.occEndPointService.buildUrl('getProducts', { queryParams: { products: productIds } });

    return this.http.get(url).pipe(
      map((response: any) => {
        return {
          products: response || [],
          ...successStatus,
        };
      }),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            message: textError,
            ...failStatus,
          })),
        );
      }),
    );
  }

  addToCartInLot(entries: SimpleEntry[]): Observable<StatusRequest> {
    return combineLatest([this.activeCartService.getActiveCartId(), this.userIdService.getUserId()]).pipe(
      switchMap(([cartId, userId]) => {
        const url = this.occEndPointService.buildUrl('addToCartInLot', { urlParams: { userId, cartId } });

        const newEntries: {
          product: string;
          quantity: number;
        }[] = entries.map(entry => ({
          product: entry.code,
          quantity: entry.qty,
        }));

        return this.http.post(url, newEntries).pipe(
          map((response: any) => {
            return {
              obj: response,
              ...successStatus,
            };
          }),
          catchError(() => {
            return this.translationService.translate('generic.error').pipe(
              map(textError => ({
                message: textError,
                ...failStatus,
              })),
            );
          }),
        );
      }),
    );
  }
}
